import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import { PanelTitle } from '@atlassian/panel-system/panel-title';

import type { PreviewPanelTitleProps } from './types';

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelTitle = ({
	title,
	icon,
	color,
}: PreviewPanelTitleProps): React.JSX.Element => {
	if (fg('ads-panel-system-gpp')) {
		return <PanelTitle icon={icon}>{title}</PanelTitle>;
	}

	return (
		<Inline space="space.100" alignBlock="center">
			{icon}
			<Text weight="bold" maxLines={1} color={color}>
				{title}
			</Text>
		</Inline>
	);
};
